import React from 'react'

import { registersEmployer } from './useEmployerMatching'

// Whether the employer will reach DTD, which the data-sharing choice decides.
// Tailwind twin: donate_v7/EmployerMatchingStatus.jsx.
const EmployerMatchingStatus = ({ i18n, employerMatching, shares }) => {
  if (!employerMatching?.enabled) return null

  const entered = employerMatching.employerEntered
  const enabled = registersEmployer(shares)

  // Mounted even when empty so AT announces the change.
  return (
    <p
      role="status"
      aria-live="polite"
      className={entered ? 'small text-muted mb-0' : 'visually-hidden'}
    >
      {entered && <>
        {i18n.t('employer_matching.status')}
        {' '}
        <span className={enabled ? 'text-success' : 'text-danger'}>
          {i18n.t(`employer_matching.${enabled ? 'status_enabled' : 'status_disabled'}`)}
        </span>
      </>}
    </p>
  )
}

export default EmployerMatchingStatus
